/* Patitas: una fuente compartida para React y Liquid. El recálculo vive en Shopify.
   No ejecuta el HTML descargado ni sustituye la grilla. Un error conserva el último saldo. */
(function () {
  'use strict';
  if (window.BeaPatitasLive) return;

  var EVENT = 'bea:patitas:update';
  var PERIOD = 60000;
  var state = null, pollTimer = 0, pending = null, failures = 0, started = false;
  var listeners = [];

  function text(value) { return typeof value === 'string' && value.trim() && value.length <= 200; }
  function number(value) { return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= Number.MAX_SAFE_INTEGER; }
  function timestamp(value) {
    if (typeof value !== 'string') return false;
    var m = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/);
    if (!m || !Number.isFinite(Date.parse(value))) return false;
    var year = Number(m[1]), month = Number(m[2]), day = Number(m[3]);
    return month >= 1 && month <= 12 && day >= 1 &&
      day <= new Date(Date.UTC(year, month, 0)).getUTCDate() &&
      Number(m[4]) < 24 && Number(m[5]) < 60 && Number(m[6]) < 60;
  }
  function valid(raw, legacyAllowed) {
    if (!raw || raw.porcentaje !== 15 || !number(raw.acumulado) || !number(raw.base) ||
        !number(raw.piezas) || !Number.isSafeInteger(raw.piezas) ||
        !number(raw.pedidos) || !Number.isSafeInteger(raw.pedidos) ||
        !text(raw.desde) || !text(raw.fecha_corte)) return null;
    var stamp = raw.actualizado_en;
    var legacy = legacyAllowed && (stamp === null || stamp === undefined || stamp === '');
    if (!legacy && (!timestamp(stamp) || Date.parse(stamp) > Date.now() + 300000)) return null;
    return Object.freeze({
      porcentaje: raw.porcentaje, acumulado: raw.acumulado, base: raw.base,
      piezas: raw.piezas, pedidos: raw.pedidos, desde: raw.desde.trim(),
      fecha_corte: raw.fecha_corte.trim(), actualizado_en: legacy ? null : stamp
    });
  }
  function read(doc, legacyAllowed) {
    var el = doc.querySelector('[data-bea-patitas-json]');
    if (!el) return null;
    try { return valid(JSON.parse(el.textContent), legacyAllowed); } catch (_) { return null; }
  }
  function amount(data) { return '$' + Math.round(data.acumulado).toLocaleString('es-AR'); }
  function dateLabel(data) {
    if (!data.actualizado_en) return 'actualizado al ' + data.fecha_corte;
    return 'actualizado el ' + new Intl.DateTimeFormat('es-AR', {
      timeZone: 'America/Argentina/Buenos_Aires', day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).format(new Date(data.actualizado_en));
  }
  function summary(data) {
    return (data.piezas === 1 ? '1 pieza vendida' : data.piezas + ' piezas vendidas') +
      ' desde el ' + data.desde + ' · ' + dateLabel(data);
  }
  function label() { return 'Total recaudado'; }
  function render() {
    if (!state) return;
    document.querySelectorAll('[data-patitas-counter]').forEach(function (box) {
      var value = box.querySelector('[data-pat-num]');
      var sub = box.querySelector('[data-pat-summary]');
      var title = box.querySelector('[data-pat-label]');
      if (value) value.textContent = amount(state);
      if (sub) sub.textContent = summary(state);
      if (title) title.textContent = label(state);
      box.setAttribute('data-pat-updated', state.actualizado_en || '');
    });
  }
  function notify() {
    render();
    listeners.slice().forEach(function (listener) { try { listener(state); } catch (_) {} });
    window.dispatchEvent(new CustomEvent(EVENT, { detail: state }));
  }
  function commit(next) {
    if (!next) return false;
    // El CDN o una respuesta atrasada nunca debe llevar el saldo a un corte anterior.
    // Una devolución sí puede bajar el importe: se acepta cuando su corte es más nuevo.
    if (state && state.actualizado_en && (!next.actualizado_en ||
        Date.parse(next.actualizado_en) < Date.parse(state.actualizado_en))) return false;
    if (state && JSON.stringify(next) === JSON.stringify(state)) { render(); return true; }
    if (state && next.actualizado_en && next.actualizado_en === state.actualizado_en) return false;
    state = next;
    notify();
    return true;
  }
  function stopTimer() { if (pollTimer) { window.clearTimeout(pollTimer); pollTimer = 0; } }
  function schedule() {
    stopTimer();
    if (document.hidden) return;
    pollTimer = window.setTimeout(refresh, Math.min(PERIOD * Math.pow(2, failures), 600000));
  }
  function endpoint() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var url = new URL(root, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Origen inválido');
    url.searchParams.set('section_id', 'bea-patitas-data');
    // La preview debe leer su propia sección, aunque el tema publicado todavía no la tenga.
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('_patitas', String(Date.now()));
    return url.toString();
  }
  function refresh() {
    stopTimer();
    if (document.hidden) return Promise.resolve(false);
    if (pending) return pending;
    var abort = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (abort) abort.abort(); }, 15000);
    pending = Promise.resolve().then(function () {
      return window.fetch(endpoint(), {
        credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'text/html' }, signal: abort ? abort.signal : undefined
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('Respuesta inválida');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = read(doc, false);
      if (!next) throw new Error('Datos inválidos');
      var accepted = commit(next);
      failures = 0;
      return accepted;
    }).catch(function () {
      failures = Math.min(failures + 1, 4);
      return false;
    }).finally(function () {
      window.clearTimeout(timeout);
      pending = null;
      render();
      schedule();
    });
    return pending;
  }
  window.BeaPatitasLive = Object.freeze({
    get: function () { return state; }, refresh: refresh, amount: amount, summary: summary, label: label,
    subscribe: function (listener) {
      if (typeof listener !== 'function') return function () {};
      listeners.push(listener);
      return function () { listeners = listeners.filter(function (item) { return item !== listener; }); };
    }
  });
  commit(read(document, true));
  function start() {
    if (started) return;
    started = true;
    render();
    refresh();
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopTimer();
    else { render(); refresh(); }
  });
  window.addEventListener('pageshow', function () { render(); refresh(); });
  document.addEventListener('shopify:section:load', function () { render(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
